import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/jt808parameterserv'

export default {
  state: {
    state_Jt808Parameter_AddObjResult: null,
    state_Jt808Parameter_GetAllResult: null,
    state_Jt808Parameter_GetPageResult: null,
    state_Jt808Parameter_GetDetailResult: null,
    state_Jt808Parameter_ModifyObjResult: null,
    state_Jt808Parameter_DeleteObjResult: null
  },
  mutations: {
    SET_JT808PARAMETER_ADDOBJ_RESULT: (state, rst) => {
      state.state_Jt808Parameter_AddObjResult = rst
    },
    SET_JT808PARAMETER_GETALL_RESULT: (state, rst) => {
      state.state_Jt808Parameter_GetAllResult = rst
    },
    SET_JT808PARAMETER_GETPAGE_RESULT: (state, rst) => {
      state.state_Jt808Parameter_GetPageResult = rst
    },
    SET_JT808PARAMETER_GETDETAIL_RESULT: (state, rst) => {
      state.state_Jt808Parameter_GetDetailResult = rst
    },
    SET_JT808PARAMETER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_Jt808Parameter_ModifyObjResult = rst
    },
    SET_JT808PARAMETER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Jt808Parameter_DeleteObjResult = rst
    }
  },
  actions: {
    Jt808ParameterServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ParameterServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808PARAMETER_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808PARAMETER_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Jt808Parameter_AddObjResult: state => {
      return state.state_Jt808Parameter_AddObjResult
    },
    get_Jt808Parameter_GetAllResult: state => {
      return state.state_Jt808Parameter_GetAllResult
    },
    get_Jt808Parameter_GetPageResult: state => {
      return state.state_Jt808Parameter_GetPageResult
    },
    get_Jt808Parameter_GetDetailResult: state => {
      return state.state_Jt808Parameter_GetDetailResult
    },
    get_Jt808Parameter_ModifyObjResult: state => {
      return state.state_Jt808Parameter_ModifyObjResult
    },
    get_Jt808Parameter_DeleteObjResult: state => {
      return state.state_Jt808Parameter_DeleteObjResult
    }
  }
}
